<div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3">

    @for (subaccount of subaccounts; track subaccount) {

        <div class="col">
            <div class="card wp-card h-100">
                <div class="card-body">
                    <h5 class="card-title">{{subaccount.subacctName}}</h5>

                    @for (pageElement of subaccount.pageElemSpecs; track pageElement) {
                        <div class="mb-2">
                            <app-page-element [pageElement]="pageElement"></app-page-element>
                        </div>
                    } @empty {
                    }
                </div>
            </div>
        </div>

    } @empty {
    }

</div>

<div class="row">
    <div class="col-6 text-center">
      <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>
    </div>
</div>                
